import { render, staticRenderFns } from "./FtthService.vue?vue&type=template&id=1bb5d936&"
import script from "./FtthService.vue?vue&type=script&lang=js&"
export * from "./FtthService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports